<template>
      <span class="watchlist-button btn btn-link" @click.stop.prevent="toggleWatchlist">
          <img v-if="useWatchlistStore().hasProduct(product_id)" loading="lazy" src="@img/icons/heart-full.svg" :alt="t('Added to Watchlist')">
          <img v-else loading="lazy" src="@img/icons/heart-empty.svg" :alt="t('Add to Watchlist')">
      </span>
</template>

<script setup>
import {useI18n} from "vue-i18n";

const props = defineProps({
    product_id: Number,
})
const { t } = useI18n()

const toggleWatchlist = () => {
    useWatchlistStore().toggleProduct(props.product_id);
};
</script>
